<template>
  <v-row justify-center>
    <v-dialog v-model="dialogFlag" id="dialogFlag" persistent max-width="600">
      <v-card>
        <v-card-title class="headline text-center">{{ textoTitulo }}</v-card-title>
        <v-card-text justify="center" class="text-xs-center text-center">
          <v-icon text-xs-center x-large color="amber">warning</v-icon>
        </v-card-text>
        <v-card-text xs12 sm12 md12 class="text-xs-center text-center">{{ text }}</v-card-text>
        <v-card-actions class="text-xs-center justify-center">
          <v-btn text @click="$emit('cancel')">{{ $t('cancelar') }}</v-btn>
          <v-btn color="red" text @click="$emit('close')">{{ textoBoton }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  props: {
    dialogFlag: Boolean,
    text: String,
    textoTitulo: {
      type: String,
      default: 'Eliminar'
    },
    textoBoton: {
      type: String,
      default: 'Eliminar'
    }
  }
}
</script>
